import type { StoreControl } from 'commons';
import type { MarkAreaComponentOption } from 'echarts';
import type { CommentModel } from '../../../services/api/models/CommentModel';
import { COMMENTARRY_BLUE, TRANSLUSCENT_GREEN } from '../types/chart.types';

export class DtisCommentsEchartsMarkArea {
  static convert(control: StoreControl, comments: CommentModel[], highlightedComment: string | null | undefined) {
    const res: MarkAreaComponentOption = { z: 3 };
    res.data = comments
      .filter((d) => !!d)
      .filter(({ mappedChannels, showInLane }) => mappedChannels.includes(control.id) && showInLane)
      .map(({ startTime, endTime, identifier }) => {
        const isHighlighted = highlightedComment === identifier;
        const from = {
          xAxis: startTime,
          identifier,
          name: `comment_${identifier}_start`,
          itemStyle: {
            color: isHighlighted ? TRANSLUSCENT_GREEN : COMMENTARRY_BLUE,
            opacity: 0.4,
            borderWith: isHighlighted ? 2 : 0,
            borderColor: TRANSLUSCENT_GREEN,
          },
          label: {
            show: false,
          },
        };
        const to = {
          xAxis: endTime,
          identifier,
          name: `comment_${identifier}_end`,
          label: {
            show: false,
          },
          itemStyle: {
            color: isHighlighted ? TRANSLUSCENT_GREEN : '#1C98B5',
            opacity: 0.4,
            borderWith: isHighlighted ? 2 : 0,
            borderColor: TRANSLUSCENT_GREEN,
          },
        };

        return [from, to];
      });
    return res;
  }
}
